module.exports = __webpack_public_path__ + "static/media/icondropdown.71c73931.svg";